import Breadcrumb from "../components/Breadcrumb";
import CertificateOne from "../components/CertificateOne";
import HeaderOne from "../components/HeaderOne";
import TutorSectionOne from "../components/TutorSectionOne";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const TutorPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Premium Tutors"} />

      {/* TutorSectionOne */}
      <TutorSectionOne />

      {/* CertificateOne */}
      <CertificateOne />

      {/* FooterOne */}
      
    </>
  );
};

export default TutorPage;
